<template>
    <div>
        <div v-if="loading" class="text-center">
            <i class="fa fa-circle-o-notch fa-spin"></i> Loading
        </div>

        <div v-else>
            <vue-headful :title="jsaEmp.jsa_name + ' [JSA] :: MeritEHS'"/>

            <h4 class="py-3 mb-4">
                <ol class="breadcrumb font-weight-bold m-0">
                    <li class="breadcrumb-item font-weight-light">
                        <router-link :to="`/jsa`">
                            <i class="fa fa-files-o"></i> JSA
                        </router-link>
                    </li>
                    <li class="breadcrumb-item font-weight-light">
                        <router-link :to="`/jsa/view/${jsaEmp.jsa_id}`">
                            {{ jsaEmp.jsa_name }}
                        </router-link>
                    </li>
                    <li class="breadcrumb-item active">
                        {{ jsaEmp.employee_first_name }} {{ jsaEmp.employee_last_name }}
                    </li>
                </ol>
            </h4>

            <div class="card mb-3">
                <div class="card-header">
                    <strong>Sign JSA: {{ jsaEmp.employee_first_name }} {{ jsaEmp.employee_last_name }}</strong>
                </div>
                <div class="card-body">
                    <VueSignaturePad ref="employeeSig" class="signature-pad" />
                </div>
                <div class="card-footer">
                    <button v-on:click="saveSignature()" class="btn btn-sm btn-primary" :disabled="signing">
                        <template v-if="!signing">
                            <i class="fa fa-pencil"></i> Sign and Date
                        </template>
                        <template v-else>
                            <i class="fa fa-spin fa-spinner"></i> Signing
                        </template>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data: function() {
            return {
                loading: true,
                signing: false,
                jsa_employee_id: this.$route.params.id,
                jsaEmp: {},
                files: [],
                new_employees: [],
                new_file: null,
                errors: {},
            }
        },

        watch: {

        },

        computed: {

        },

        methods: {

            getJsaEmp() {
                //Get the data
                this.$http
                    .get('jsa/signature/' + this.jsa_employee_id)
                    .then(response => {
                        //Set all the data
                        this.jsaEmp = response.data.jsa_employee;

                        //Set loading
                        this.loading = false;
                    })
                    .catch(response => {

                    });
            },

            saveSignature(){
                //This returns a boolean and a data:image stream.
                //Is empty is whether or not the signature is populated.
                const { isEmpty, data } = this.$refs.employeeSig.saveSignature();

                //Check for empty
                if(isEmpty)
                {
                    //alert the user
                    alert('Signature Cannot be Empty');

                    //Stop here
                    return;
                }

                //Signing
                this.signing = true;

                //Send it
                this.$http.post('/jsa/signature/'+this.jsaEmp.id, {signature: data})
                    .then(res => {
                        //Alert the User
                        this.$toastr.success('JSA Signed and Dated');

                        //Send to the View
                        this.$router.push('/jsa/view/'+this.jsaEmp.jsa_id+'#employees');
                    })
                    .catch(err => {
                        //Alert
                        console.log(err);
                    })
                    .then(() => {
                        //reset
                        this.signing = false;
                    });
            },

        },

        mounted() {
            //Get the JSA
            this.getJsaEmp();
        }
    }
</script>
